import React, { useState, useEffect, useRef } from "react";
import { Layout } from "..";
import { Container } from "./styled";
import { UpgradeContainer } from "../../components";
import Modal from "../../modal";
import { addModal } from "../../lib/addModal";
import secureLocalStorage from "react-secure-storage";
import { Link, useLocation } from "react-router-dom";
import firebase from "../../lib/fire";

export const optionsBarChart = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
    },
  },
};
function AnalyticsDashboard() {
  const [showModal, setShowModal] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [optionsToShow, setOptionsToShow] = useState(null);
  const [sharedClips, setSharedClips] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const hasLoadedDataRef = useRef(false);
  const [sharedCollections, setSharedCollections] = useState(() => {
    try {
      const user = secureLocalStorage.getItem("user");
      if (user && user.sharedCollections) {
        return user.sharedCollections;
      }
      return [];
    } catch (err) {
      console.error("Error reading sharedCollections from localStorage:", err);
      return [];
    }
  });

  const userId = secureLocalStorage.getItem("userId");
  const sessionUser = sessionStorage.getItem("user");
  const location = useLocation();
  const urlParts = location.pathname.split("/");
  let slug = urlParts[2];

  useEffect(() => {
    if (urlParts.length > 3) {
      setActiveTab(urlParts[3]);
    } else if (urlParts.length === 3) {
      setActiveTab(null);
    }
  }, [slug, urlParts]);

  function toggleModal() {
    setShowModal(!showModal);
    if (!showModal) {
      document.getElementById("modal").style.display = "flex";
    } else {
      document.getElementById("modal").style.display = "none";
    }
  }

  async function adminData(collectionId) {
    try {
      const response = await fetch(
        `https://deportactico-vercel-serverless.vercel.app/api/getCollectionWithClips`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({ userId: userId, collectionId }),
        }
      );

      if (!response.ok) {
        console.error(
          `❌ Error HTTP ${response.status}: ${response.statusText}`
        );
        return null;
      }

      const record = await response.json();
      if (!record) {
        console.warn("⚠️ No se encontró la colección");
        return null;
      }

      return record;
    } catch (error) {
      console.error("❌ Error en adminData:", error);
      return null;
    }
  }

  const showHistoryOptions = (options) => {
    let optionsDiv = document.getElementsByClassName(
      `options-${options.id}`
    )[0];
    let optionsToRemove = document.getElementsByClassName(`options`);
    for (var i = 0; i < optionsToRemove.length; i++) {
      optionsToRemove[i].classList.remove("active");
    }
    if (optionsDiv.classList.contains("active")) {
      optionsDiv.classList.remove("active");
    } else {
      optionsDiv.classList.add("active");
    }
  };

  async function confirmDeleteClick() {
    try {
      if (optionsToShow.type === "ownClip") {
        const res = await fetch(
          "https://deportactico-vercel-serverless.vercel.app/api/deleteClip",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              clipId: optionsToShow.id,
              senderId: userId,
            }),
          }
        );

        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Error borrando clip");

        let user = JSON.parse(sessionUser);
        const updatedObject = Object.fromEntries(
          Object.entries(user.analyticsClips).filter(
            ([, clip]) => clip.id !== optionsToShow.id
          )
        );
        user.analyticsClips = updatedObject;
        secureLocalStorage.setItem("user", user);
        sessionStorage.setItem("user", JSON.stringify(user));
      } else if (optionsToShow.type === "board") {
        await firebase
          .database()
          .ref(`/users/0/${userId}/analyticsBoards/${optionsToShow.id}`)
          .remove();
      } else if (optionsToShow.type === "sharedClip") {
        const clip = Object.values(JSON.parse(sessionUser).sharedWithMe).find(
          (clip) => clip.clipId === optionsToShow.id
        );

        const res = await fetch(
          "https://deportactico-vercel-serverless.vercel.app/api/deleteSharedClip",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              clipId: clip.clipId,
              senderId: clip.senderId,
              receiverId: userId,
              templateId: clip.templateId,
            }),
          }
        );

        const data = await res.json();
        if (!res.ok)
          throw new Error(data.error || "Error borrando clip compartido");

        let user = JSON.parse(sessionUser);
        const sharedWithMe = user.sharedWithMe || {};

        delete sharedWithMe[optionsToShow.id];

        const compositeKey = `${optionsToShow.senderId}_${optionsToShow.templateId}`;
        const stillHasTemplate = Object.entries(sharedWithMe)
          .filter(([key]) => key !== "byTemplate")
          .some(
            ([, val]) =>
              val.templateId === optionsToShow.templateId &&
              val.senderId === optionsToShow.senderId
          );

        if (!stillHasTemplate && sharedWithMe.byTemplate?.[compositeKey]) {
          delete sharedWithMe.byTemplate[compositeKey];
        }

        user.sharedWithMe = sharedWithMe;
        secureLocalStorage.setItem("user", user);
        sessionStorage.setItem("user", JSON.stringify(user));
      } else if (optionsToShow.type === "collection") {
        const res = await fetch(
          "https://deportactico-vercel-serverless.vercel.app/api/deleteClipCollection",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              clipId: optionsToShow.id,
              senderId: userId,
            }),
          }
        );

        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Error borrando clip");

        let user = JSON.parse(sessionUser);
        const updatedObject = Object.fromEntries(
          Object.entries(user.clipCollections).filter(
            ([, clip]) => clip.id !== optionsToShow.id
          )
        );
        user.clipCollections = updatedObject;
        secureLocalStorage.setItem("user", user);
        sessionStorage.setItem("user", JSON.stringify(user));
      }

      setShowModal(false);
      document.getElementById("modal").style.display = "none";
      addModal({ modal: "SuccessModal", linkTo: `/app/analytics-dashboard` });
    } catch (error) {
      console.error("Error deleting clip:", error);
      addModal({ modal: "ErrorModal", linkTo: `/app/analytics-dashboard` });
    }
  }

  useEffect(() => {
    if (showOptions) showHistoryOptions(optionsToShow);
  }, [showOptions]);

  async function loadSharedClips() {
    const response = await fetch(
      "https://deportactico-vercel-serverless.vercel.app/api/getSharedClipsWithBoards",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      }
    );

    const data = await response.json();
    if (data.sharedClips) {
      const userData = JSON.parse(sessionUser);
      userData.sharedClips = data.sharedClips;

      secureLocalStorage.setItem("user", userData);
      sessionStorage.setItem("user", JSON.stringify(userData));
      setSharedClips(data.sharedClips);
    }
  }

  async function loadSharedCollectionsWithData() {
    const userData = JSON.parse(sessionUser);
    if (!userData || !userData.sharedCollections) return;

    const collRefsObj = userData.sharedCollections;
    const collRefs = Object.values(collRefsObj);

    const updatedCollections = {};

    for (const ref of collRefs) {
      const collectionData = await adminData(ref.collectionId);
      if (collectionData) {
        updatedCollections[ref.collectionId] = {
          ...ref,
          ...collectionData,
        };
      } else {
        updatedCollections[ref.collectionId] = ref;
      }
    }

    const updatedUser = {
      ...userData,
      sharedCollections: updatedCollections,
    };

    secureLocalStorage.setItem("user", updatedUser);
    sessionStorage.setItem("user", JSON.stringify(updatedUser));

    setSharedCollections(updatedCollections);
  }

  useEffect(() => {
    if (!sessionUser || hasLoadedDataRef.current) return;

    hasLoadedDataRef.current = true;
    loadSharedClips();
    loadSharedCollectionsWithData();
  }, [sessionUser]);

  return (
    <Layout>
      <>
        {sessionUser ? (
          (() => {
            const user = JSON.parse(sessionUser);
            const isPremium = user.plan !== "Basic";

            return (
              <Container>
                {showModal ? (
                  <Modal>
                    <div className="modal">
                      <div class="modal-img-container">
                        <img
                          style={{ width: "30%" }}
                          src="/assets/delete-icon.svg"
                          className="trash-can-button"
                          alt=""
                        />
                        <h1>Eliminar plantilla</h1>
                        <p>
                          Estás seguro que deseas eliminar esta plantilla?
                          <br></br>
                          <span className="delete-warning">
                            No será posible recuperarla.
                          </span>
                        </p>
                      </div>
                      <div className="delete-modal-buttons">
                        <button
                          className="delete-button"
                          onClick={() => {
                            confirmDeleteClick();
                          }}
                        >
                          Eliminar
                        </button>
                        <button
                          className="cancel-button"
                          onClick={() => {
                            toggleModal();
                          }}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </Modal>
                ) : null}
                <div className="navbar">
                  <div className="navbar-content">
                    <div className="flex_center_space-between header-links-container">
                      <ul>
                        <li>
                          <Link
                            className={activeTab === null ? "active" : null}
                            to={`/app/analytics-dashboard`}
                          >
                            Plantillas
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={activeTab === "clips" ? "active" : null}
                            to={`/app/analytics-dashboard/clips`}
                          >
                            Clips
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={
                              activeTab === "sharedClips" ? "active" : null
                            }
                            to={`/app/analytics-dashboard/sharedClips`}
                          >
                            Clips compartidos
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={
                              activeTab === "colections" ? "active" : null
                            }
                            to={`/app/analytics-dashboard/colections`}
                          >
                            Colecciones
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={
                              activeTab === "sharedCollections"
                                ? "active"
                                : null
                            }
                            to={`/app/analytics-dashboard/sharedCollections`}
                          >
                            Colecciones compartidas
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {isPremium && (
                  <>
                    {activeTab === null ? (
                      <div className="boards-container">
                        <div className="board-card">
                          <h3 className="title">Analisis Deportactico</h3>
                          <p className="description">
                            Comparativas generales entre equipos
                          </p>
                          <Link className="btn-primary" to="/app/analytics">
                            Usar
                          </Link>
                        </div>
                        {JSON.parse(sessionUser).analyticsBoards !==
                          undefined &&
                          JSON.parse(sessionUser).analyticsBoards?.map(
                            (routine, i) => (
                              <div className="board-card">
                                <div
                                  className="options-container"
                                  onClick={(e) => {
                                    setShowOptions(!showOptions);
                                    setOptionsToShow({ id: i, type: "board" });
                                  }}
                                >
                                  <p className="menu">...</p>
                                  {showOptions ? (
                                    <ul className={`options options-${i}`}>
                                      <li className="edit">
                                        <img
                                          src="/assets/edit-icon.svg"
                                          alt=""
                                        />
                                        <a href={`/app/edit-dashboard/${i}`}>
                                          Editar
                                        </a>
                                      </li>
                                      <li
                                        className="delete"
                                        onClick={() => {
                                          toggleModal();
                                        }}
                                      >
                                        <img
                                          src="/assets/delete-icon.svg"
                                          className="trash-can-button"
                                          alt=""
                                        />
                                        <p>Eliminar</p>
                                      </li>
                                    </ul>
                                  ) : null}
                                </div>
                                <h3 className="title">{routine?.name}</h3>
                                <p className="description">
                                  {routine?.description}
                                </p>
                                <Link
                                  className="btn-primary"
                                  to={`/app/analytics/${i}`}
                                >
                                  Usar
                                </Link>
                              </div>
                            )
                          )}
                        <div className="board-card">
                          <h3 className="title">Crear plantilla</h3>
                          <p className="description">
                            Crea tu plantilla personalizada
                          </p>
                          <Link
                            className="btn-primary ghost"
                            to="/app/dnd-dashboard"
                          >
                            Empezar
                          </Link>
                        </div>
                      </div>
                    ) : activeTab === "clips" ? (
                      JSON.parse(sessionUser)?.analyticsClips &&
                      Object.values(JSON.parse(sessionUser)?.analyticsClips) ? (
                        <div className="boards-container">
                          {JSON.parse(sessionUser).analyticsClips !==
                            undefined &&
                            JSON.parse(sessionUser).analyticsClips !== null &&
                            Object.values(
                              JSON.parse(sessionUser).analyticsClips
                            ).map((clip, i) => (
                              <div className="board-card">
                                <div
                                  className="options-container"
                                  onClick={(e) => {
                                    setShowOptions(!showOptions);
                                    setOptionsToShow({
                                      id: clip.id,
                                      type: "ownClip",
                                    });
                                  }}
                                >
                                  <p className="menu">...</p>
                                  {showOptions ? (
                                    <ul
                                      className={`options options-${clip.id}`}
                                    >
                                      <li
                                        className="delete"
                                        onClick={() => {
                                          toggleModal();
                                        }}
                                      >
                                        <img
                                          src="/assets/delete-icon.svg"
                                          className="trash-can-button"
                                          alt=""
                                        />
                                        <p>Eliminar</p>
                                      </li>
                                    </ul>
                                  ) : null}
                                </div>
                                <h3 className="title">{clip?.name}</h3>
                                <Link
                                  className="btn-primary"
                                  to={`/app/analytics/C-${clip.id}`}
                                >
                                  Ver
                                </Link>
                              </div>
                            ))}
                        </div>
                      ) : null
                    ) : activeTab === "colections" ? (
                      JSON.parse(sessionUser).clipCollections &&
                      Object.values(JSON.parse(sessionUser).clipCollections) ? (
                        <div className="boards-container">
                          {JSON.parse(sessionUser).clipCollections !==
                            undefined &&
                            JSON.parse(sessionUser).clipCollections !== null &&
                            Object.values(
                              JSON.parse(sessionUser).clipCollections
                            ).map((collection, i) => (
                              <div className="board-card">
                                <div
                                  className="options-container"
                                  onClick={(e) => {
                                    setShowOptions(!showOptions);
                                    setOptionsToShow({
                                      id: collection.id,
                                      type: "collection",
                                    });
                                  }}
                                >
                                  <p className="menu">...</p>
                                  {showOptions ? (
                                    <ul
                                      className={`options options-${collection.id}`}
                                    >
                                      <li
                                        className="delete"
                                        onClick={() => {
                                          toggleModal();
                                        }}
                                      >
                                        <img
                                          src="/assets/delete-icon.svg"
                                          className="trash-can-button"
                                          alt=""
                                        />
                                        <p>Eliminar</p>
                                      </li>
                                    </ul>
                                  ) : null}
                                </div>
                                <h3 className="title">{collection?.name}</h3>
                                <Link
                                  className="btn-primary"
                                  to={{
                                    pathname: `/app/collection/${collection.id}`,
                                    state: { collection },
                                  }}
                                >
                                  Ver
                                </Link>
                              </div>
                            ))}
                        </div>
                      ) : null
                    ) : null}
                  </>
                )}
                {activeTab === "sharedClips"
                  ? user?.sharedWithMe &&
                    Object.values(user.sharedWithMe).length > 0 && (
                      <>
                        <div className="boards-container">
                          {sharedClips?.map((clip, i) => (
                            <div className="board-card" key={clip.id}>
                              <div
                                className="options-container"
                                onClick={(e) => {
                                  setShowOptions(!showOptions);
                                  setOptionsToShow({
                                    id: clip.id,
                                    type: "sharedClip",
                                  });
                                }}
                              >
                                <p className="menu">...</p>
                                {showOptions ? (
                                  <ul className={`options options-${clip.id}`}>
                                    <li
                                      className="delete"
                                      onClick={() => {
                                        toggleModal();
                                      }}
                                    >
                                      <img
                                        src="/assets/delete-icon.svg"
                                        className="trash-can-button"
                                        alt=""
                                      />
                                      <p>Eliminar</p>
                                    </li>
                                  </ul>
                                ) : null}
                              </div>
                              <h3 className="title">{clip.name}</h3>
                              <Link
                                className="btn-primary"
                                to={`/app/analytics/C-${clip.id}`}
                              >
                                Ver
                              </Link>
                            </div>
                          ))}
                        </div>
                        {!isPremium && !user.sharedWithMe && (
                          <UpgradeContainer />
                        )}
                      </>
                    )
                  : null}
                {activeTab === "sharedCollections"
                  ? user?.sharedCollections &&
                    Object.values(user.sharedCollections).length > 0 && (
                      <>
                        <div className="boards-container">
                          {JSON.parse(sessionUser).sharedCollections !==
                            undefined &&
                            JSON.parse(sessionUser).sharedCollections !==
                              null &&
                            Object.values(
                              JSON.parse(sessionUser).sharedCollections
                            ).map((collection, i) => (
                              <div className="board-card">
                                <h3 className="title">{collection?.name}</h3>
                                <Link
                                  className="btn-primary"
                                  to={{
                                    pathname: `/app/collection/${collection.id}`,
                                    state: { collection },
                                  }}
                                >
                                  Ver
                                </Link>
                              </div>
                            ))}
                        </div>
                        {!isPremium && !user.sharedWithMe && (
                          <UpgradeContainer />
                        )}
                      </>
                    )
                  : null}
                {!isPremium && (
                  <div className="update-suscriptio-container">
                    <h2 style={{ marginBottom: "0" }}>
                      Actualiza la suscripón para crear tus analisis
                    </h2>
                    <p>Contactate con ventas para tener más informacion.</p>
                    <div className="btns-container">
                      <a className="btn-primary" href="/app/suscriptions">
                        Empieza ahora
                      </a>
                      <a className="btn-primary ghost" href="/app/login">
                        INICIA SESIÓN
                      </a>
                    </div>
                  </div>
                )}
              </Container>
            );
          })()
        ) : (
          <UpgradeContainer />
        )}
      </>
    </Layout>
  );
}

export default AnalyticsDashboard;
